var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 25",
    cx: 11.825,
    cy: 11.4349,
    r: 10.72,
    stroke: "#EFEFF0",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon metro-linkedin",
    d: "M14.7131 6.40991H8.39753C7.51891 6.40991 6.80005 7.12874 6.80005 8.00732V14.3226C6.80005 15.2012 7.51891 15.92 8.39753 15.92H14.7131C15.5918 15.92 16.3106 15.2012 16.3106 14.3226V8.00732C16.3106 7.12874 15.5918 6.40991 14.7131 6.40991ZM10.3665 14.1369H9.17769V9.97621H10.3665V14.1369ZM9.7721 9.38183C9.44382 9.38183 9.17769 9.11571 9.17769 8.78744C9.17769 8.45918 9.44382 8.19306 9.7721 8.19306C10.1004 8.19306 10.3665 8.45918 10.3665 8.78744C10.3665 9.11571 10.1004 9.38183 9.7721 9.38183ZM14.5274 14.1369H13.3386V11.7594C13.3386 11.4311 13.0724 11.165 12.7442 11.165C12.4159 11.165 12.1497 11.4311 12.1497 11.7594V14.1369H10.9609V9.97621H12.1497V10.7143C12.3949 10.3775 12.7697 9.97621 13.19 9.97621C13.9286 9.97621 14.5274 10.6415 14.5274 11.4622L14.5274 14.1369Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.15ebb7ad3f7329d04153877143dffb5c.svg";
export { ForwardRef as ReactComponent };